import { QueryFunctionContext, useQuery } from "@tanstack/react-query";
import { configuration } from "../../../configuration";
import { FetchError, GetSurveyInstancesDto } from "../../types";
import { useAccessToken } from "../../use-access-token";
import { queryKeys } from "../queryKeys";

const useGetSurveyInstancesRequest = () => {
  const { getAccessToken } = useAccessToken();

  async function getSurveyInstancesRequest({
    queryKey,
  }: QueryFunctionContext<ReturnType<typeof queryKeys.surveys.getSurveyInstances>>): Promise<GetSurveyInstancesDto> {
    const accessToken = await getAccessToken();
    const [{ surveyGuid }] = queryKey;

    const response = await fetch(`${configuration.apiRootUrl}/surveys/${surveyGuid}/instances`, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });

    if (!response.ok) {
      throw new FetchError(response);
    }

    return response.json();
  }

  return { getSurveyInstancesRequest };
};

const useGetSurveyInstances = (surveyGuid: string) => {
  const { getSurveyInstancesRequest } = useGetSurveyInstancesRequest();

  return useQuery({
    queryKey: queryKeys.surveys.getSurveyInstances(surveyGuid),
    queryFn: getSurveyInstancesRequest,
  });
};

export { useGetSurveyInstances };
